/* eslint-disable no-restricted-globals */
import axios from 'axios';
import https from 'https';

const apiSinister = axios.create({
  baseURL: `/sinistro`,
  httpsAgent: new https.Agent({
    rejectUnauthorized: true,
  }),
});

export default apiSinister;
